import React from "react";
import PropTypes from "prop-types";
import get from "lodash/get";
import { Link } from "@quintype/components";
import { getStoryHeading } from "../../../utils";
import "./headline.m.css";

export const Headline = ({
  story,
  headlineColor = "#231f20",
  externalLink = false,
  isStoryPage = false
}) => {
  const slug =
    story["story-template"] === "news-elsewhere"
      ? get(story, ["metadata", "reference-url"], story.url)
      : story.url;
  const headline = isStoryPage ? story.headline : getStoryHeading(story);
  return externalLink ? (
    story["story-template"] === "news-elsewhere" ? (
      <a href={slug} target="_blank" rel="noopener noreferrer">
        <h2
          styleName="headline"
          className="headline"
          style={{ color: headlineColor }}
        >
          <bdi dangerouslySetInnerHTML={{ __html: headline }} />
        </h2>
      </a>
    ) : (
      <Link
        href={slug}
        target={story["story-template"] === "news-elsewhere" ? "_blank" : ""}
      >
        <h2
          styleName="headline"
          className="headline"
          style={{ color: headlineColor }}
        >
          <bdi dangerouslySetInnerHTML={{ __html: headline }} />
        </h2>
      </Link>
    )
  ) : (
    <h2
      styleName="headline"
      className="headline"
      style={{ color: headlineColor }}
    >
      <bdi dangerouslySetInnerHTML={{ __html: headline }} />
    </h2>
  );
};

Headline.propTypes = {
  story: PropTypes.object,
  headlineColor: PropTypes.object,
  externalLink: PropTypes.string,
  isStoryPage: PropTypes.bool
};
